//调用入口
export default{
	
	
	initSystemData (context,obj) {
	      context.commit('initSystemData',obj)
	    },
	Login (context,obj) {
	      context.commit('Login',obj)
	    }	,
	LogOut (context) {
		 context.commit('LogOut')
	},
	SetQuery (context,obj) {
		 context.commit('SetQuery',obj)
	},
	SetSearch (context,obj) {
		 context.commit('SetSearch',obj)
	}
	
	
}